import Header from "./components/Header";
import Footer from "./components/Footer";
import { client } from "./api/Client";
import { useEffect, useState } from "react";
import Vedio from "./components/Vedio";
import "./styles/WorkPage.css";
export default function Work() {
  let [Vedios, setVedios] = useState();
  let [Images, setImages] = useState();
  useEffect(() => {
    client
      .get("/GetVedios/100000")
      .then((res) => {
        setVedios(res.data.Vedios);
      })
      .catch((error) => alert(error));
    client
      .get("/GetImages")
      .then((res) => {
        setImages(res.data.Images);
      })
      .catch((error) => alert(error));
  }, []);
  return (
    <>
      <Header />
      <div className="title">
        <h2>Vedios :</h2>
      </div>
      <div className="ContainerWorkPage">
        {Vedios?.map((item) => {
          return (
            <>
              <Vedio linkVedio={item.VedioURL} />
            </>
          );
        })}
      </div>
      <div className="title">
        <h2>Images :</h2>
      </div>
      <div className="ContainerWorkPage">
        {Images?.map((item) => {
          return (
            <>
              <div className="Card">
                <img src={ item.ImgURL} alt={ item.Bio } width="450px" height="auto" />
                <h2>
                  { item.Bio }
                </h2>
              </div>
              
            </>
          );
        })}
      </div>
      <Footer />
    </>
  );
}
